import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { HeaderProps } from './types';
import { classNames } from './classNames';

import Classes from './ListingOtherSellerHeader.module.scss';

const Header: React.FC<HeaderProps> = ({ url, totalResults, showAlsoFromText = true }) => {
  const textKey = totalResults > 0 ? 'subListing.seeOthers' : 'subListing.seeAll';

  return (
    <div className={Classes[classNames.headerSection]}>
      {showAlsoFromText && (
        <Trans tagName="span" className={Classes[classNames.paragraph]} i18nKey="subListing.alsoFrom" />
      )}
      <a className={Classes[classNames.textLink]} rel="nofollow" href={url}>
        <Trans tagName="span" i18nKey={textKey} totalSellerListingsResults={totalResults} />
      </a>
    </div>
  );
};

export default Header;
